import React, { memo } from 'react';
import SiteFinder from '../OpbMng/SiteFinder';

// 소속: 팀명 선택
export const DamdangOrgSelect = memo(function DamdangOrgSelect({ orgCodes, damdangOrg, handleValueChange, pubType, disabled }) {

    return (
        <>
            <select name="damdangOrg" onChange={handleValueChange} className={`input-box w100per padding-l5${disabled ? " disabled-select" : ""}`} value={damdangOrg} disabled={disabled}>
                <option value="">팀명 선택</option>
                {pubType === "derv" && <option value="-1" >전체</option>}
                {orgCodes && orgCodes.map((code, i) => <option key={i} value={code.code}>{code.name}</option>)}
            </select>
        </>
    );
});

// 소속: 보수사무소 선택
export const DamdangOfficeSelect = memo(function DamdangOfficeSelect({ officeCodes, damdangOrg, damdangOffice, handleValueChange, pubType, disabled }) {

    return (
        <>
            <select name="damdangOffice" onChange={handleValueChange} className={`input-box w100per padding-l5${(disabled || damdangOrg === "") ? " disabled-select" : ""}`} value={damdangOffice} disabled={(disabled || damdangOrg === "")}>
                <option value="">보수사무소 선택</option>
                {officeCodes && officeCodes.map((code, i) => <option key={i} value={code.code}>{code.name}</option>)}
            </select>
        </>
    );
});

// 지역: 지역 선택
export const DamdangRegionSelect = memo(function DamdangRegionSelect({ regionCodes, damdangRegion, handleValueChange, pubType, disabled }) {

    return (
        <>
            <select name="damdangRegion" onChange={handleValueChange} className={`input-box w100per padding-l5${disabled ? " disabled-select" : ""}`} value={damdangRegion} disabled={disabled}>
                <option value="">지역 선택</option>
                {regionCodes && regionCodes.map((code, i) => <option key={i} value={code.code}>{code.name}</option>)}
            </select>
        </>
    );
});

// 현장명: 현장명 입력 + 현장찾기
export const SiteNameInputSiteFinder = memo(function SiteNameInputSiteFinder({ opbSearch, siteName, handleValueChange, handleSiteInfo }) {
    return (
        <>
            <div className="div-table-display">
                <div className="w100per">
                    <input className="input-box w100per padding-l10" placeholder="현장명 입력" name="siteName" value={siteName} onChange={handleValueChange} />
                </div>
                <div>
                    <SiteFinder opbSearch={opbSearch} handleSiteInfo={handleSiteInfo} />
                </div>
            </div>
        </>
    );
});

// 현장명: 현장명 입력
export const SiteNameInput = memo(function SiteNameInput({ siteName, handleValueChange, disabled }) {
    return (
        <>
            <input className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="현장명 입력" name="siteName" value={siteName} onChange={handleValueChange} disabled={disabled} />
        </>
    );
});

// 호기번호: 호기번호 입력
export const OpbNoInput = memo(function OpbNoInput({ opbNo, handleValueChange, disabled }) {
    return (
        <>
            <input className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="호기번호 입력" name="opbNo" value={opbNo} onChange={handleValueChange} disabled={disabled} />
        </>
    );
});

// 호기번호: 호기번호 선택
export const OpbNoSelect = memo(function OpbNoSelect({ opbList, opbNo, handleValueChange }) {
    return (
        <>
            <select name="opbNo" onChange={handleValueChange} className="input-box w100per padding-l5" value={opbNo}>
                <option value="-1">호기 선택</option>
                {opbList && opbList.map((opbInfo, i) => <option key={i} value={opbInfo.opbNo}>{opbInfo.opbNo}호기</option>)}
            </select>
        </>
    );
});

// 호기이름: 호기이름 입력
export const OpbNameInput = memo(function OpbNameInput({ opbName, handleValueChange, disabled }) {
    return (
        <>
            <input className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="호기이름 입력" name="opbName" value={opbName} onChange={handleValueChange} disabled={disabled} />
        </>
    );
});

// IMEI: IMEI 입력
export const IMEIInput = memo(function IMEIInput({ imei, handleValueChange }) {
    return (
        <>
            <input className="input-box w100per padding-l10" placeholder="IMEI 입력" name="imei" value={imei} onChange={handleValueChange} />
        </>
    );
}
);

// 승강기ID: 승강기ID 입력
export const ElvNoInput = memo(function ElvNoInput({ elvNo, handleValueChange, disabled }) {
    return (
        <>
            <input className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="승강기ID 입력" name="elvNo" value={elvNo} onChange={handleValueChange}  disabled={disabled} />
        </>
    );
});

// PrjNo: 현장번호 입력
export const SiteNumInput = memo(function SiteNumInput({ siteNum, handleValueChange, disabled }) {
    return (
        <>
            <input className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="PrjNo 입력" name="siteNum" value={siteNum} onChange={handleValueChange} disabled={disabled} />
        </>
    );
});

// PrjNo: 현장번호 입력 + 현장찾기
export const SiteNumInputSiteFinder = memo(function SiteNumInputSiteFinder({ opbSearch, siteNum, handleValueChange, handleSiteInfo }) {
    return (
        <>
            <div className="div-table-display text-align-center">
                <div className="w100per">
                    <input className="input-box w100per padding-l10" placeholder="PrjNo 입력" name="siteNum" value={siteNum} onChange={handleValueChange} />
                </div>
                <div>
                    <SiteFinder opbSearch={opbSearch} handleSiteInfo={handleSiteInfo} />
                </div>
            </div>
        </>
    );
});

// Display타입: 보드 선택 + 타입 선택
export const OpbTypeSelect = memo(function OpbTypeSelect({ boardCodes, typeCodes, boardCode, typeCode, handleValueChange, disabled }) {
    return (
        <>
            <div className="row inner-row">
                <div className="col">
                    <select name="boardCode" onChange={handleValueChange} className={`input-box w100per padding-l5${disabled ? " disabled-select" : ""}`} value={boardCode} disabled={disabled}>
                        <option value="">보드 선택</option>
                        {boardCodes && boardCodes.map((code, i) => <option key={i} value={code.code}>{code.name}</option>)}
                    </select>
                </div>
                <div className="col">
                    <select name="typeCode" onChange={handleValueChange} className={`input-box w100per padding-l5${(disabled || boardCode === "") ? " disabled-select" : ""}`} value={typeCode} disabled={disabled || boardCode === ""}>
                        <option value="">타입 선택</option>
                        {typeCodes && typeCodes.map((code, i) => <option key={i} value={code.code}>{code.name}</option>)}
                    </select>
                </div>
            </div>
        </>
    );
});

// 계약상태: 전체/정상/중단/만료 선택
export const OpbStatusSelect = memo(function OpbStatusSelect({ opbStatusCodes, opbStatus, handleValueChange }) {
    return (
        <>
            <select name="opbStatus" onChange={handleValueChange} className="input-box w100per padding-l5" value={opbStatus}>
                <option value="">전체</option>
                {opbStatusCodes && opbStatusCodes.filter(code => code.code !== 'ST004').map((code, i) => <option key={i} value={code.code}>{code.name}</option>)}
            </select>
        </>
    );
});

// Display위치: 장치유형 선택
export const SlotCodeSelect = memo(function SlotCodeSelect({ slotCodes, slotCode, handleValueChange, disabled }) {
    return (
        <>
            <select className={`input-box w100per padding-l5${disabled ? " disabled-select" : ""}`} name="slotCode" value={slotCode} onChange={handleValueChange} disabled={disabled}>
                <option value="">Display위치 선택</option>
                {slotCodes && slotCodes.map((code, i) => <option key={i} value={code.code}>{code.name}</option>)}
            </select>
        </>
    );
});

// 최저층설정: 최저층타입 선택 + 최저층 입력
export const FloorStartInput = memo(function FloorStartInput({ floorStartType, floorStart, handleValueChange, typeDisabled, disabled }) {
    return (
        <>
            <div className="div-table-display text-align-center">
                <div className="w45per">
                    <select className={`input-box w100per padding-l10${typeDisabled ? " disabled-select" : ""}`} name="floorStartType" value={floorStartType} onChange={handleValueChange} disabled={typeDisabled} >
                        <option value="">최저층 선택</option>
                        <option value="지상">1층</option>
                        <option value="지하">지하</option>
                    </select>
                </div>
                <div className="w45per">
                    <input type="number" className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`}
                        name="floorStart" value={disabled ? "" : Math.abs(floorStart)}
                        onChange={handleValueChange} disabled={disabled}
                    />
                </div>
                <div className="w10per">층</div>
            </div>
        </>
    );
});

// 최고층설정: 최고층 입력
export const FloorEndInput = memo(function FloorEndInput({ floorEnd, handleValueChange, disabled }) {
    return (
        <>
            <div className="div-table-display text-align-center">
                <div className="w90per">
                    <input type="number" className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="최고층 입력" name="floorEnd" value={floorEnd} onChange={handleValueChange} disabled={disabled} />
                </div>
                <div className="w10per">층</div>
            </div>
        </>
    );
}
);

// 계약기간: 시작/종료일 입력
export const BeginEndDateInput = memo(function BeginEndDateInput({ beginDate, endDate, disabled }) {
    return (
        <>
            <div className="div-table-display text-align-center">
                <div>
                    <input className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="계약 시작일" name="beginDate" value={beginDate} disabled={disabled} />
                </div>
                <div>~</div>
                <div>
                    <input className={`input-box w100per padding-l10${disabled ? " disabled-input" : ""}`} placeholder="계약 종료일" name="endDate" value={endDate} disabled={disabled} />
                </div>
            </div>
        </>
    );
});




